import React, { Component } from 'react';
import { connect } from 'react-redux';

// import store from '../../store';

let counter = 1;

class Modify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            focus: false
        }
    }

    handleKeyPress = (event) => {
        // console.log(e.key);
        if (this.state.focus) {
            if (event.key === 'ArrowDown') {
                if (this.refs['atc' + (counter + 1)]) counter++;
                if (this.refs['atc' + (counter - 1)] && this.refs['atc' + counter]) this.refs['atc' + (counter - 1)].style = '';
                if (this.refs['atc' + counter]) {
                    console.log(this.refs['atc' + counter].style);
                    this.refs['atc' + counter].style = 'background:#e5e5e5';
                    this.refs.atc.scrollTop = (counter - 1) * 37;
                }
            }
            if (event.key === 'ArrowUp') {
                if (counter !== 1) counter--;
                if (this.refs['atc' + (counter + 1)] && this.refs['atc' + counter]) this.refs['atc' + (counter + 1)].style = '';
                if (this.refs['atc' + counter]) {
                    this.refs['atc' + counter].style = 'background:#e5e5e5';
                    this.refs.atc.scrollTop = (counter - 1) * 37;
                }
            }
            if (event.key === 'Tab') {
                this.props.setValue(this.refs['atc' + counter].innerHTML, true);
                this.setState({ focus: false })
                counter = 1;
            }
            if (event.key === 'Enter') {
                this.props.setValue(this.refs['atc' + counter].innerHTML, true);
                this.setState({ focus: false })
                counter = 1;
            }
        }
    }

    selCity = (city) => {
        this.props.setValue(city, true);
        this.setState({ focus: false });
    }

    showDropDown = () => {
        if (this.props.list.length > 0) {
            return <div className = 'atc' ref = 'atc'>{ this.showAtc(this.props.list) }</div>
        } else {
            return <div ref = 'atc'><div>Loading...</div></div>
        }
    }

    showAtc = (list) => {
        let i = 0;
        const loop = list;
        const city = this.props.value;
        return (
            loop.map((el, index) => {
                if (el.toLowerCase().indexOf(city.toLowerCase()) === 0) {
                    i++;
                    return <div key = { index } ref = {'atc' + i} onClick = { () => this.selCity(el) }>{ el }</div>
                } else {
                    return ''
                }
            })
        )
    }

    render() {
        return (
            <div style = {this.props.style}>
                <input
                    type = 'text'
                    placeholder = { this.props.placeholder }
                    value = { this.props.value }
                    onChange = { (event) => this.props.setValue(event.target.value, false) }
                    onFocus = { () => this.setState({ focus: true }) }
                    onBlur = { () => setTimeout(() => { this.setState({ focus: false }) }, 500) }
                    onKeyDown = { this.handleKeyPress }
                    className = 'ty-text'
                    style = { this.inpS }
                />
                { this.state.focus ? this.showDropDown() : '' }
                { this.props.value ? <span style = { this.clearS } onClick = { () => { this.props.setValue('', true);this.setState({ focus: true}) } }>&#x2715;</span> : '' }
            </div>
        );
    }

    inpS = {
        width: '100%',
        background: this.props.err ? 'rgba(255, 0, 0, 0.2)' : '#fff',
        padding: this.props.padding ? '15px 15px 15px 25px' : '15px',
        border: '0',
        outline: '0',
        borderRight: '1px solid #ddd',
        borderRadius: '3px',
        color: '#444',
        fontWeight: '300'
    }

    clearS = {
        position: 'absolute',
        right: this.props.padding ? '15px' : '25px',
        top: '15px',
        color: '#666'
    }
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(Modify);